<template>
  <stage-card-info-list>
    <template #header>Screening Tasks</template>
    <template #content>
      <bubble-info-list-item
        v-if="referencesWithNoVotes"
        :bubble-text="referencesWithNoVotes"
      >
        References with no votes
      </bubble-info-list-item>
      <bubble-info-list-item
        v-if="partialNeedingUserVote"
        :bubble-text="partialNeedingUserVote"
      >
        Partial screens you can vote on
      </bubble-info-list-item>
      <bubble-info-list-item
        v-if="conflicts"
        :bubble-text="conflicts"
      >
        Conflicts to resolve
      </bubble-info-list-item>

      <stage-card-info-list-item v-if="showEmptyState">
        No tasks to complete
      </stage-card-info-list-item>
    </template>
  </stage-card-info-list>
</template>

<script>
import StageCardInfoList from '@/components/DashboardTab/StageCardInfoList';
import StageCardInfoListItem from '@/components/DashboardTab/StageCardInfoListItem';
import BubbleInfoListItem from '@/components/DashboardTab/BubbleInfoListItem';
import { Review } from '@/models';

export default {
  name: 'ScreeningTasks',
  components: {
    StageCardInfoList,
    StageCardInfoListItem,
    BubbleInfoListItem,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    referencesWithNoVotes() {
      const count = this.review.screeningProgressSummary
        .unscreenedCount;
      if (count === 0) return null;
      return this.review.screeningProgressSummary.unscreenedCount.toLocaleString();
    },
    partialNeedingUserVote() {
      const count = this.review.screeningProgressSummary
        .userRequiredVoteCount;
      if (count === 0) return null;
      return count.toLocaleString();
    },
    conflicts() {
      const count = this.review.screeningProgressSummary
        .conflictedScreenCount;
      if (count === 0) return null;
      return count.toLocaleString();
    },
    showEmptyState() {
      return (
        !this.referencesWithNoVotes &&
        !this.partialNeedingUserVote &&
        !this.conflicts
      );
    },
  },
};
</script>
